
export default {
    install(Vue, options) {
        Vue.prototype.$Log = function (msg) {
            if (this.$root.config.isDebug) {
                msg = this.$moment().format('DD.MM.YYYY HH:mm:ss ............') + msg;
                console.log(msg);
            }
        }

        Vue.prototype.$ForceLog = function (msg) {
            msg = this.$moment().format('DD.MM.YYYY HH:mm:ss ............') + msg;
            console.log(msg);
        }
    }
}


// WEBPACK FOOTER //
// ./src/plugins/log.js